// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
// -- Helpers END

windowLoad(function() {
	$(".news-tabs__top").on("click", ".news-tabs__top-tab:not(.news-tabs__top-tab_active)", function() {
		const tabId = $(this).data("tab")
		if (!tabId) return

		$(this)
			.addClass("news-tabs__top-tab_active")
			.siblings()
			.removeClass("news-tabs__top-tab_active")
			.closest(".news-tabs")
			.find(".news-tabs__content")
			.removeClass("active")

		$(`.news-tabs__content[data-tab="${tabId}"]`)
			.addClass("active");
	});
});
